import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { httpGet } from '../../../../components/utils';

const useGetHiddenIncidentTypes = () => {
    const [data, setData] = useState<number[]>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const fetchIncidentHiddenTypes = async () => {
            setIsFetching(true);
            setError(undefined);

            try {
                const response = (await httpGet('/incidents/hiddenTypes')) as unknown as AxiosResponse<number[]>;

                setData(response.data);
            } catch (err) {
                setError('Failed to get incidents severity overview from server');
            }
            setIsFetching(false);
        };

        fetchIncidentHiddenTypes();
    }, []);

    return { data, isFetching, error };
};

export default useGetHiddenIncidentTypes;
